/**
 * Constantes para el componente EditarEvaluacion
 */

// Estados de carga
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING_COMBOS: 'loading_combos',
  LOADING_DATA: 'loading_data',
  LOADING_CARGOS: 'loading_cargos',
  SAVING: 'saving'
};

// Pasos del wizard
export const STEPS = {
  INFORMACION_BASICA: 1,
  CONFIGURACION: 2,
  PREGUNTAS: 3,
  REVISION: 4
};

export const STEP_TITLES = {
  [STEPS.INFORMACION_BASICA]: 'Información Básica',
  [STEPS.CONFIGURACION]: 'Configuración',
  [STEPS.PREGUNTAS]: 'Preguntas',
  [STEPS.REVISION]: 'Revisión'
};

// Límites de validación
export const VALIDATION_LIMITS = {
  TIEMPO_LIMITE_MAX: 43200, // 30 días en minutos
  PUNTAJE_MAX: 1000,
  PESO_CALIFICACION_MAX: 100,
  PESO_CALIFICACION_MIN: 1
};

// Mensajes de error
export const ERROR_MESSAGES = {
  NOMBRE_REQUERIDO: 'El nombre de la evaluación es obligatorio',
  TIPO_PRUEBA_REQUERIDO: 'Debe seleccionar un tipo de prueba',
  TIPO_CARGO_REQUERIDO: 'Debe seleccionar un tipo de cargo',
  CARGOS_REQUERIDOS: 'Debe seleccionar al menos un cargo específico',
  TIEMPO_LIMITE_REQUERIDO: 'El tiempo límite debe ser mayor a 0 minutos',
  PREGUNTAS_REQUERIDAS: 'Debe agregar al menos una pregunta'
};

// Valores por defecto
export const DEFAULT_VALUES = {
  TIEMPO_LIMITE: 60,
  PUNTAJE_APROBATORIO: 0,
  PESO_CALIFICACION: 1.0,
  ESTADO_ACTIVO: true,
  ES_OBLIGATORIA: false
};

// Configuración de UI
export const UI_CONFIG = {
  CARGOS_MULTISELECT_HEIGHT: '200px',
  INSTRUCCIONES_MIN_HEIGHT: '120px',
  STEP_CONTENT_MIN_HEIGHT: '400px'
};

export default {
  LOADING_STATES,
  STEPS,
  STEP_TITLES,
  VALIDATION_LIMITS,
  ERROR_MESSAGES,
  DEFAULT_VALUES,
  UI_CONFIG
};